import { NavLink, useLocation } from "react-router-dom";

import "./Drawerpages.scss";

const Drawerpages = (props) => {
  
  const location = useLocation();
  const currentPath = location.pathname;
  return (
    <NavLink
      className={"link"}
      // className={({ isActive, isPending }) =>
      //   isPending ? `pending link` : isActive ? `active link` : "link"
      // }
      // style={{ textDecoration: 'none' }}

      to={`/${props?.data?.Route}`}
    >
      <div className={`${props?.name} ${"/" + props?.data?.Route === currentPath ? "active" : "pending"} `}>
        <p className="linkText">{props?.data?.Page_Name}</p>
      </div>
    </NavLink>
  );
};

export default Drawerpages;
